// @flow

import React, { type Node } from 'react';
import { useUniqueId } from '@tectonics/hooks';
import { getImplementedTraits } from '@tectonics/look-and-feel';
import { useFieldMetadata } from '@tectonics/prs/form';
import { useCurrentAllFeatures } from '@tectonics/prs/payment-spec';
import { useUserInputAsRadioButton } from '@tectonics/prs/user-input-values';
import { getBrandSource } from './cash/brands';
import { ErrorMessage, Margin, Padding, RadioButton } from '../../../atoms';
import lookAndFeel from '../../../index';
import { compareBankOptionsOrder } from '@tectonics/prs/argentina';

export function FieldArgentineCashBankList(): Node {
  const id = useUniqueId();
  const allFeatures = useCurrentAllFeatures();
  const bankCodes = [
    ...getImplementedTraits(lookAndFeel, 'field_argentine_cash_bank_list', allFeatures),
  ].sort(compareBankOptionsOrder);

  const { formHasBeenSent, submitting, validationError } = useFieldMetadata('selectedBankCode');
  const [selectedBankCode, onSelectBankCode] = useUserInputAsRadioButton('selectedBankCode');

  return (
    <Margin top={2} style={{ width: '100%' }} noFirst data-test-name="payment-type-code">
      <Padding x={1}>
        <strong>Selecciona el método de pago:</strong>

        {bankCodes.map((bankCode) => (
          <label key={bankCode} style={labelStyle} htmlFor={`${id}-${bankCode}`}>
            <RadioButton
              name="payment_type_code"
              data-test-value={bankCode}
              value={bankCode}
              id={`${id}-${bankCode}`}
              disabled={submitting}
              checked={bankCode == selectedBankCode}
              onChange={onSelectBankCode}
            />
            <img src={getBrandSource(bankCode)} alt={bankCode} style={{ maxWidth: '38px', margin: '0 10px' }} />
            {getBankLabelText(bankCode)}
          </label>
        ))}

        {formHasBeenSent && validationError && (
          <ErrorMessage>Selecciona el método de pago</ErrorMessage>
        )}
      </Padding>
    </Margin>
  );
}

const labelStyle = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  marginTop: '12px',
  cursor: 'pointer',
};

function getBankLabelText(bankCode: string): Node {
  switch (bankCode) {
    case 'pagofacil':
      return 'Pagofacil';
    case 'rapipago':
      return 'Rapipago';
    default:
      throw new Error(`Cash label text "${bankCode}" not supported`);
  }
}
